import { apiCall } from './base';

export const fetchCandidates = (name = '', role = '', others = '') =>
  apiCall(`/candidates`, { method: 'GET', params: { name, role, others } });

export const fetchCandidate = (hash) => apiCall(`/candidates/${hash}`);

export const postCandidate = ({ immediately = false, ...data }) =>
  apiCall(`/candidates`, { method: 'POST', data, immediately });

export const updateCandidate = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}`, { method: 'PUT', data, immediately });

export const updateCandidateOverview = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}`, { method: 'PUT', data, immediately });

export const deleteCandidate = (hash, { immediately = false }) =>
  apiCall(`/candidates/${hash}`, {
    method: 'DELETE',
    immediately,
});
  
export const fetchCandidateSkills = (hash) => apiCall(`/candidates/${hash}/skills`);

export const postCandidateSkill = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}/skills`, { method: 'POST', data, immediately });

export const deleteCandidateSkill = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}/skills`, {
    method: 'DELETE',
    data,
    immediately,
  });
  
export const fetchCandidateDegrees = (hash) => apiCall(`/candidates/${hash}/degrees`);

export const postCandidateDegree = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}/degrees`, { method: 'POST', data, immediately });

export const deleteCandidateDegree = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}/degrees`, {
    method: 'DELETE',
    data,
    immediately,
  });

export const fetchCandidateCertifications = (hash) => apiCall(`/candidates/${hash}/certifications`);

export const postCandidateCertification = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}/certifications`, { method: 'POST', data, immediately });

export const deleteCandidateCertification = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}/certifications`, {
    method: 'DELETE',
    data,
    immediately,
  });
  
export const fetchCandidateQuotes = (hash) => apiCall(`/candidates/${hash}/quotes`);

export const postCandidateQuote = (hash, { immediately = false, ...data }) =>
apiCall(`/candidates/${hash}/quotes`, { method: 'POST', data, immediately });

export const deleteCandidateQuote = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}/quotes`, {
    method: 'DELETE',
    data,
    immediately,
  });

export const fetchCandidateExperiences = (hash) =>apiCall(`/candidates/${hash}/experiences`);

export const postCandidateExperience = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}/experiences`, { method: 'POST', data, immediately });

export const deleteCandidateExperience = (hash, { immediately = false, ...data }) =>
  apiCall(`/candidates/${hash}/experiences`, {
    method: 'DELETE',
    data,
    immediately,
  });

export const scheduleAnInterview = (hash, data) =>
  apiCall(`/candidates/${hash}/interview`, { method: 'POST', data });

export const postCandidatePortfolio = (hash, { immediately = false, ...data } ) =>
  apiCall(`/candidates/${hash}/portfolio`, {
    method: 'POST',
    data,
    immediately,
});
  
export const cloneCandidate = (hash) => apiCall(`/candidates/${hash}/clone`, { method: 'POST' });

export const completeCandidateFromPdf = (hash, data) =>
  apiCall(`/candidates/${hash}/completeFromPdf`, { method: 'POST', data });

export const getCandidatesByDate = ({ immediately = false, ...data }) =>
  apiCall(`/candidates/candidates-by-date`, { method: 'PUT', data });